import gql from 'graphql-tag';

export const dokkioLabelCapabilitiesFragment = gql`
  fragment dokkioLabelCapabilitiesFragment on DokkioLabelCapabilities {
    dokkioClass
    canEdit
    canDelete
  }
`;

export default dokkioLabelCapabilitiesFragment;
